import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-event-popup',
  imports: [],
  templateUrl: './event-popup.html',
  styleUrl: './event-popup.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventPopup {
  @Output() closed = new EventEmitter<void>();

  today = new Date();

  events = [
    {
      image: 'assets/events/Flyer FAL Contadores.jpg',
      alt: 'Evento Contadores',
      expiresAt: new Date('2026-05-19T23:59:59')
    },
    {
      image: 'assets/events/Flyer FAL PyMEs.png',
      alt: 'Evento PyMEs',
      expiresAt: new Date('2026-05-21T23:59:59')
    }
  ];

  get activeEvents() {
    return this.events.filter(
      event => this.today <= event.expiresAt
    );
  }

  closePopup() {
    this.closed.emit();
  }
}
